<template>
  <div class="brand-mark-container__background">
    <img src="@/assets/logo-main.svg" class="brand-mark-logo__main"/>
  </div>
</template>

<script>
export default {
  name: 'BrandMark',
  props: {
   
  },
};
</script>

<style scoped src="./BrandBackground.css"></style>
